/*
 * Created on Tue Jul 30 2019
 * Author: Val Liu
 * Copyright (c) 2019
 */

import { Vue } from "vue-property-decorator";

export const LifeCyclesPlugin = {
    install: function (Vue: any) {
        if (Vue._val_life_cycles_installed) return;
        Vue._val_life_cycles_installed = true;

        Vue.mixin({
            created() {
                this.$emit("created", this);
            },
            mounted() {
                this.$emit("mounted", this);
            },
            destroyed() {
                this.$emit("destroyed", this);
            },
        });
    },
};
